import gql from 'graphql-tag'

export const GET_CDM_DEVICE_STATUSES = gql`
  query VehicleStatusesPaginated($filter: GetVehicleStatusesWithPaginationInput) {
    vehicleStatusesPaginated(filter: $filter) {
      errorCode
      errorName
      isSuccessful
      message
      status
      vehicleStatusesPaginated {
        data {
          vehicleId
          licensePlate
          lastPacket
          latitude
          longitude
          door1Status
          temperature
          battery
          accuVoltage
          address
          vehicle {
            sensorTrigStartTime
            sensorTrigEndTime
            vehicleType {
              category
              icon
              manufacturer
              model
              type
              vehicleTypeId
            }
            children {
              id
            }
            vehicle2Vgroup {
              vgroup {
                name
              }
              vgroupId
            }
          }
        }
        pagination {
          total
          page
          show
        }
      }
    }
  }
`

export const SET_BUZZER_STATUS = gql`
  mutation SetBuzzerStatus($input: SetBuzzerStatusInput) {
    setBuzzerStatus(input: $input) {
      isSuccessful
      setBuzzerStatus {
        commandStatus
      }
    }
  }
`
